import api from '../api';
import { entregarArquivo } from '../platform/arquivos';

const base = '/api/financas';

export const financasApi = {
  // Transações
  listarTransacoes: (params = {}) => api.get(`${base}/transacoes`, { params }),
  criarTransacao: (data) => api.post(`${base}/transacoes`, data),
  atualizarTransacao: (id, data) => api.put(`${base}/transacoes/${id}`, data),
  deletarTransacao: (id) => api.delete(`${base}/transacoes/${id}`),

  // Categorias
  listarCategorias: (params = {}) => api.get(`${base}/categorias`, { params }),
  criarCategoria: (data) => api.post(`${base}/categorias`, data),
  atualizarCategoria: (id, data) => api.put(`${base}/categorias/${id}`, data),
  deletarCategoria: (id) => api.delete(`${base}/categorias/${id}`),

  // Métodos
  listarMetodos: (params = {}) => api.get(`${base}/metodos-pagamento`, { params }),
  criarMetodo: (data) => api.post(`${base}/metodos-pagamento`, data),
  atualizarMetodo: (id, data) => api.put(`${base}/metodos-pagamento/${id}`, data),
  deletarMetodo: (id) => api.delete(`${base}/metodos-pagamento/${id}`),

  // Resumo / Caixa
  resumo: (params = {}) => api.get(`${base}/resumo`, { params }),
  caixa: (params = {}) => api.get(`${base}/caixa`, { params }),
  getCaixaInicial: (params = {}) => api.get(`${base}/caixa-inicial`, { params }),
  setCaixaInicial: (data) => api.put(`${base}/caixa-inicial`, data),

  // Extrato
  extrato: (params = {}) => api.get(`${base}/extrato`, { params }),
  extratoPdfUrl: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return `${base}/extrato/pdf?${qs}`;
  },
  baixarExtratoPdf: async (params = {}) => {
    const res = await api.get(`${base}/extrato/pdf`, { params, responseType: 'blob' });
    await entregarArquivo(res.data, `extrato_${params.inicio || 'mes'}_${params.fim || ''}.pdf`);
  },
};

export default financasApi;
